import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from '../widgets.module.sass'
import { useState } from 'react'
import SegmentedControl from '@jimmyboys/liita-ui/dist/components/SegmentedControl'
import AppointmentsProtocols from './AppointmentsProtocols'
import MedicalActsProtocols from './MedicalActsProtocols'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import useSession from 'hooks/useSession'
import { Segment } from 'utils/enums'
import {
	APPOINTMENT_PROTOCOLS,
	MEDICAL_ACT_PROTOCOLS,
} from 'dialogs/DataEditingDialogs/EditProcessProtocolDialog/EditProcessProtocolDialog'

const renderSelectedTab = (
	selectedTab,
	appointmentProcessProtocols,
	medicalActProcessProtocols,
	providerEntities,
	medicalActs,
	requisitions,
	appointments,
	medicalSpecialties
) => {
	switch (selectedTab) {
		case 'appointments':
			return (
				<AppointmentsProtocols
					data={{
						appointmentProcessProtocols,
						providerEntities,
						appointments,
						medicalSpecialties,
					}}
				/>
			)
		case 'medicalActs':
			return (
				<MedicalActsProtocols
					data={{
						medicalActProcessProtocols,
						providerEntities,
						medicalActs,
						requisitions,
					}}
				/>
			)
		default:
			return null
	}
}

const ProcessProtocolsWidget = (props) => {
	const { data } = props
	const {
		appointmentProcessProtocols,
		medicalActProcessProtocols,
		providerEntities,
		medicalActs,
		requisitions,
		process,
		appointments,
		medicalSpecialties,
	} = data
	const { i18n, showDialog } = useGlobal()
	const { user: sessionUser } = useSession()

	const isAdministrative = sessionUser?.roles.includes('manager')
	const isAdmin = sessionUser?.roles?.some(
		(role) => role.toLowerCase() === 'admin'
	)

	const tabs = [
		{
			id: 'appointments',
			text: i18n`Appointments (${
				appointmentProcessProtocols?.length || 0
			})`,
		},
		{
			id: 'medicalActs',
			text: i18n`Medical Acts (${
				medicalActProcessProtocols?.length || 0
			})`,
		},
	]

	const [selectedTab, setSelectedTab] = useState(tabs[0].id)

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='reports'
			title={i18n`Process Protocols`}
			collapsedLabel={
				appointmentProcessProtocols?.length ??
				medicalActProcessProtocols?.length
			}
			expanded={true}
			borderRadius
			margins={['small', '', '']}
			paddings={['', 'xsmall', 'xsmall']}
		>
			<SegmentedControl
				className={styles['protocols-segment-control']}
				selectedTab={selectedTab}
				onSelect={(e) => {
					setSelectedTab(e.id)
				}}
				selectorType={'border'}
				tabs={tabs}
			/>
			{renderSelectedTab(
				selectedTab,
				appointmentProcessProtocols,
				medicalActProcessProtocols,
				providerEntities,
				medicalActs,
				requisitions,
				appointments,
				medicalSpecialties
			)}
			{process?.id &&
				(isAdministrative || isAdmin) &&
				(process?.accident?.segment?.abbreviation ===
					Segment.WorkRelated ||
					process?.accident?.segment?.abbreviation ===
						Segment.TrafficAccident) &&
				(APPOINTMENT_PROTOCOLS || MEDICAL_ACT_PROTOCOLS) && (
					<Widget
						className={styles['centered']}
						paddings={['small', '', '']}
						justify='center'
					>
						<ActionButton
							secondary
							onClick={() => {
								showDialog(
									'EditProcessProtocolDialog',
									i18n`Edit Process Protocols`,
									{
										processId: process.id,
										accidentType:
											process?.accident?.segment
												?.abbreviation,
										postalCode:
											process?.injured?.postalCode,
									},
									false,
									undefined,
									'center',
									'edit_process_protocol'
								).catch(() => null)
							}}
						>
							<small>
								<strong>{i18n`Edit protocols`}</strong>
							</small>
						</ActionButton>
					</Widget>
				)}
		</ExpandableWidget>
	)
}

export default ProcessProtocolsWidget
